import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, unref as _unref, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "field-container" }
const _hoisted_2 = { class: "tooltip" }
const _hoisted_3 = {
  key: 0,
  class: "multiselect__element-placeholder"
}

import Multiselect from 'vue-multiselect'
import { useGettext } from 'vue3-gettext'
import IconUI from '@/components/CommonUI/IconUI.vue'

interface Props {
  options: unknown[],
  value?: unknown[],
  emptyListText?: string,
  noResultText?: string,
  inputLabel?: string,
  inputLabelClass?: string,
  tooltipInfoText?: string,
  disabled?: boolean,
  showBeforeList?: boolean,
  hideLabel?: boolean,
  hasError?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiselectUI',
  props: {
    options: {},
    value: { default: undefined },
    emptyListText: { default: 'List is empty.' },
    noResultText: { default: 'No element found. Consider changing the search query.' },
    inputLabel: { default: '' },
    inputLabelClass: { default: '' },
    tooltipInfoText: { default: '' },
    disabled: { type: Boolean, default: false },
    showBeforeList: { type: Boolean, default: false },
    hideLabel: { type: Boolean, default: false },
    hasError: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { $gettext } = useGettext()


return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.inputLabel)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["label", { inputLabelClass: _ctx.inputLabelClass, 'screen-reader-only': _ctx.hideLabel }])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.inputLabel), 1),
          _createElementVNode("span", _hoisted_2, [
            (_ctx.tooltipInfoText)
              ? _withDirectives((_openBlock(), _createBlock(IconUI, {
                  key: 0,
                  "data-testid": `${_ctx.inputLabel} icon`,
                  name: "tooltip",
                  fill: "info"
                }, null, 8, ["data-testid"])), [
                  [_directive_tippy, { content: _ctx.tooltipInfoText }]
                ])
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_unref(Multiselect), _mergeProps({
      multiple: "",
      "preserve-search": "",
      "hide-selected": "",
      "clear-on-select": "",
      "close-on-select": "",
      searchable: "",
      class: { 'has-error': _ctx.hasError },
      disabled: _ctx.disabled,
      "show-labels": false,
      "group-select": false
    }, _ctx.$attrs, { options: _ctx.options }), {
      beforeList: _withCtx(() => [
        (_ctx.showBeforeList)
          ? _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_3, [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Select from:")
                ]),
                _: 1
              })
            ], 512)), [
              [_vShow, _ctx.value?.length !== _ctx.options.length]
            ])
          : _createCommentVNode("", true)
      ]),
      caret: _withCtx(() => [
        _createVNode(IconUI, {
          class: "icon multiselect__select",
          name: "search",
          fill: _ctx.disabled ? 'medium-grey' : 'blue-alternate'
        }, null, 8, ["fill"])
      ]),
      noOptions: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref($gettext)(_ctx.emptyListText)), 1)
      ]),
      noResult: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref($gettext)(_ctx.noResultText)), 1)
      ]),
      _: 1
    }, 16, ["class", "disabled", "options"])
  ]))
}
}

})